import React, {useState, useMemo} from 'react'
import {useIntl} from 'react-intl'
import {Container, Row, Col, Form, Badge} from 'react-bootstrap'
import {PageTitle} from '../../core'
import {helpArticles} from './data/helpArticles'
import {HelpArticleCard} from './components/HelpArticleCard'
import {HelpArticleModal} from './components/HelpArticleModal'

const CATEGORIES = ['Tüm Kategoriler', ...Array.from(new Set(helpArticles.map((a) => a.category)))]

const HelpCenter = () => {
  const intl = useIntl()
  const [searchTerm, setSearchTerm] = useState('')
  const [selectedCategory, setSelectedCategory] = useState('Tüm Kategoriler')
  const [selectedArticle, setSelectedArticle] = useState(null)

  const filteredArticles = useMemo(() => {
    let result = helpArticles

    if (selectedCategory !== 'Tüm Kategoriler') {
      result = result.filter((a) => a.category === selectedCategory)
    }

    if (searchTerm.trim()) {
      const term = searchTerm.trim().toLowerCase()
      result = result.filter(
        (a) =>
          a.title.toLowerCase().includes(term) ||
          a.summary.toLowerCase().includes(term) ||
          a.tags.some((tag) => tag.toLowerCase().includes(term))
      )
    }

    return result
  }, [searchTerm, selectedCategory])

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({id: 'MENU.HELP'})}
      </PageTitle>

      <Container fluid className='py-6'>
        {/* Başlık ve Arama */}
        <Row className='justify-content-center mb-6'>
          <Col md={8} lg={6}>
            <div className='text-center mb-4'>
              <h1 className='fw-bold text-dark fs-2'>
                {intl.formatMessage({id: 'MENU.HELP'})}
              </h1>
              <p className='text-muted'>Adım adım kılavuzlar ve kullanım rehberleri</p>
            </div>
            <Form.Control
              type='search'
              placeholder={intl.formatMessage({id: 'HELP.SEARCH.PLACEHOLDER'})}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className='form-control-lg'
            />
          </Col>
        </Row>

        {/* Kategori Filtreleri */}
        <Row className='justify-content-center mb-6'>
          <Col xs='auto'>
            <div className='d-flex flex-wrap gap-2 justify-content-center'>
              {CATEGORIES.map((cat) => (
                <Badge
                  key={cat}
                  bg={selectedCategory === cat ? 'primary' : 'light'}
                  text={selectedCategory === cat ? 'white' : 'dark'}
                  className='px-3 py-2 fs-7 border'
                  style={{cursor: 'pointer', userSelect: 'none'}}
                  onClick={() => setSelectedCategory(cat)}
                >
                  {cat === 'Tüm Kategoriler'
                    ? intl.formatMessage({id: 'HELP.CATEGORY.ALL'})
                    : cat}
                </Badge>
              ))}
            </div>
          </Col>
        </Row>

        {/* Kart Izgarası */}
        {filteredArticles.length === 0 ? (
          <Row className='justify-content-center'>
            <Col md={6} className='text-center py-10'>
              <div className='text-muted fs-5'>
                {intl.formatMessage({id: 'HELP.NO_RESULT'})}
              </div>
            </Col>
          </Row>
        ) : (
          <Row xs={1} md={2} lg={3} className='g-4'>
            {filteredArticles.map((article) => (
              <Col key={article.id}>
                <HelpArticleCard article={article} onClick={setSelectedArticle} />
              </Col>
            ))}
          </Row>
        )}
      </Container>

      <HelpArticleModal article={selectedArticle} onClose={() => setSelectedArticle(null)} />
    </>
  )
}

export {HelpCenter}
